import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { useSelector } from "react-redux";
import asyncComponent from "../../../util/asyncComponent";
import { hasWorkflowOpsAccess } from "./access";
import { DeniedState } from "./components/SurfaceState";
import "./workflowOperations.css";

const WorkflowOperations = ({ match }) => {
  const authUser = useSelector((state) => state.auth?.authUser || null);
  const hasAccess = hasWorkflowOpsAccess(authUser);

  if (!hasAccess) {
    return (
      <div className="app-wrapper">
        <div className="workflow-ops-panel mt-3">
          <DeniedState />
        </div>
      </div>
    );
  }

  return (
    <div className="app-wrapper">
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/control-tower`} />
        <Redirect exact from={match.url} to={`${match.url}/control-tower`} />

        <Route
          exact
          path={`${match.url}/control-tower`}
          component={asyncComponent(() => import("./routes/ControlTowerPage"))}
        />
        <Route
          exact
          path={`${match.url}/trades`}
          component={asyncComponent(() => import("./routes/TradeWorklistPage"))}
        />
        <Route
          exact
          path={`${match.url}/trades/:tradeSagaId`}
          component={asyncComponent(() => import("./routes/TradeDetailPage"))}
        />
        <Route
          exact
          path={`${match.url}/smartfolio-sessions`}
          component={asyncComponent(() => import("./routes/SmartfolioWorklistPage"))}
        />
        <Route
          exact
          path={`${match.url}/smartfolio-sessions/:smartfolioOrderSessionSagaId`}
          component={asyncComponent(() => import("./routes/SmartfolioDetailPage"))}
        />
        <Route
          exact
          path={`${match.url}/advanced-repairs`}
          component={asyncComponent(() => import("./routes/AdvancedRepairWorkbenchPage"))}
        />
        <Route
          exact
          path={`${match.url}/operations/:operationId`}
          component={asyncComponent(() => import("./routes/OperationDrillDownPage"))}
        />
        <Route
          exact
          path={`${match.url}/accounts/:tradingAccountId`}
          component={asyncComponent(() => import("./routes/DeferredSurfacePage"))}
        />
        <Route
          exact
          path={`${match.url}/:deferredSurface(queue-retry|reconciliation|cash|action-requests|repair-preview|raw-records)`}
          component={asyncComponent(() => import("./routes/DeferredSurfacePage"))}
        />

        <Route
          component={asyncComponent(() =>
            import("app/routes/extraPages/routes/404")
          )}
        />
      </Switch>
    </div>
  );
};

export default WorkflowOperations;
